import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة تأثير التضخم على المال";
const DESCRIPTION =
  "حاسبة تأثير التضخم تقوم بحساب كمية الأموال التي تفقد قيمتها بسبب التضخم بين فترتين زمنيتين مختلفتين.";
const KEYWORDS = "تأثير التضخم على المال, حساب تأثير التضخم, حاسبة التضخم";
const OG_URL = "https://do-calculate.com/calculator/ar/inflation";
function InflationCalculator() {
  const [initialAmount, setInitialAmount] = useState("");
  const [initialDollarRate, setInitialDollarRate] = useState("");
  const [finalDollarRate, setFinalDollarRate] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!initialAmount || !initialDollarRate || !finalDollarRate) {
      setError("الرجاء إدخال جميع القيم بشكل صحيح");
      setResult("");
      return;
    }
    const initialAmountValue = parseFloat(initialAmount);
    const initialDollarRateValue = parseFloat(initialDollarRate);
    const finalDollarRateValue = parseFloat(finalDollarRate);
    if (
      isNaN(initialAmountValue) ||
      isNaN(initialDollarRateValue) ||
      isNaN(finalDollarRateValue)
    ) {
      setError("الرجاء إدخال قيم صحيحة للأرقام");
      setResult("");
      return;
    }
    const initialValueInDollars = initialAmountValue / initialDollarRateValue;
    const finalValueInDollars = initialAmountValue / finalDollarRateValue;
    const lossInDollars = initialValueInDollars - finalValueInDollars;
    const lossPercentage = (lossInDollars / initialValueInDollars) * 100;
    setResult(
      `المبلغ الأصلي بالدولار: ${initialValueInDollars.toFixed(2)} دولار <br/>
            القيمة بعد التضخم بالدولار: ${finalValueInDollars.toFixed(
              2
            )} دولار <br/>
            الخسارة بالدولار: ${lossInDollars.toFixed(2)} دولار <br/>
            النسبة المئوية للخسارة: ${lossPercentage.toFixed(2)}%`
    );
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب تأثير التضخم</h2>
                <p>
                  طريقة حساب تأثير التضخم تتمثل في حساب الفرق في قيمة المال بين
                  فترتين مختلفتين بناءً على معدل التضخم.
                </p>
                <p>الخسارة = المبلغ الأصلي - القيمة بعد التضخم</p>
                <p>النسبة المئوية للخسارة = (الخسارة / المبلغ الأصلي) * 100%</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">المبلغ الأصلي</label>
                      </b>
                      <input
                        type="number"
                        placeholder="10000"
                        value={initialAmount}
                        onChange={(e) => setInitialAmount(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          قيمة المبلغ الاصلي بالدولار{" "}
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="30"
                        value={initialDollarRate}
                        onChange={(e) => setInitialDollarRate(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          قيمة المبلغ الاصلي بالدولار في الفترة الثانية{" "}
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="40"
                        value={finalDollarRate}
                        onChange={(e) => setFinalDollarRate(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب تأثير التضخم
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {result !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              النتيجة:
                            </p>
                            <p
                              className="p-3 mb-2 bg-info text-black"
                              dangerouslySetInnerHTML={{ __html: result }}
                            ></p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={500}></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default InflationCalculator;
